import { useState, useCallback } from "react";

// Standard error red (NOT the brand pink) is used everywhere errors are shown.
export const V = {
  required: (v) => (v === undefined || v === null || String(v).trim() === "") ? "Campo obbligatorio" : null,
  email: (v) => (!v || !String(v).trim()) ? null : (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(v).trim()) ? null : "Email non valida"),
  cf: (v) => (!v || !String(v).trim()) ? null : (/^([A-Za-z0-9]{11}|[A-Za-z0-9]{16})$/.test(String(v).trim()) ? null : "Codice fiscale o P.IVA non valido (11 o 16 caratteri)"),
  phone: (v) => {
    if (!v || !String(v).trim()) return null;
    const d = String(v).replace(/[^\d]/g, "");
    return (d.length >= 6 && d.length <= 15) ? null : "Numero di telefono non valido";
  },
  nonNegative: (v) => {
    if (v === "" || v == null) return null;
    const n = Number(v);
    return isNaN(n) ? null : (n < 0 ? "L'importo non può essere negativo" : null);
  },
  password: (v) => {
    if (!v) return "Campo obbligatorio";
    const classes = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/].filter((r) => r.test(v)).length;
    return (v.length >= 12 && classes >= 3) ? null : "Min 12 caratteri con almeno 3 tra: minuscole, maiuscole, numeri, simboli";
  },
};

export const errSummary = (n) =>
  `Non è stato possibile salvare: controlla ${n === 1 ? "il campo evidenziato" : `i ${n} campi evidenziati`} in rosso.`;

export function runRules(rules, values) {
  const errs = {};
  for (const [field, validators] of Object.entries(rules || {})) {
    const list = Array.isArray(validators) ? validators : [validators];
    for (const fn of list) {
      const msg = fn(values[field], values);
      if (msg) { errs[field] = msg; break; }
    }
  }
  return errs;
}

// Scroll to the first field in error and focus its control (works across all shared forms,
// which tag the wrapper with data-field-error="true").
function focusFirst() {
  setTimeout(() => {
    const el = document.querySelector('[data-field-error="true"]');
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.querySelector("input,select,textarea")?.focus();
    }
  }, 60);
}

export function useFormErrors() {
  const [errors, setErrors] = useState({});
  const clear = useCallback((name) => setErrors((e) => {
    if (!e[name]) return e;
    const n = { ...e }; delete n[name]; return n;
  }), []);
  // Client-side validation. Returns the errors object (empty = ok).
  const validate = useCallback((rules, values) => {
    const errs = runRules(rules, values);
    setErrors(errs);
    if (Object.keys(errs).length) focusFirst();
    return errs;
  }, []);
  // Map server validation errors ({detail:{field_errors:{...}}}) onto the right fields.
  const applyServer = useCallback((err) => {
    const d = err?.response?.data?.detail ?? err?.response?.data;
    const fe = (d && typeof d === "object" && d.field_errors) ? d.field_errors : null;
    if (fe && typeof fe === "object" && Object.keys(fe).length) {
      setErrors(fe); focusFirst(); return true;
    }
    return false;
  }, []);
  const count = Object.keys(errors).length;
  const summary = count ? errSummary(count) : "";
  return { errors, setErrors, clear, validate, applyServer, count, summary };
}
